import { BroadcastChannel } from 'broadcast-channel';

import { LOGOUT_BROADCAST_CHANNEL_NAME } from './constants';

export default function broadcastLogoutChannel() {
  const channel = new BroadcastChannel(LOGOUT_BROADCAST_CHANNEL_NAME);
  channel.postMessage('logout');
  channel.close();
}
